class Header {
  constructor() {
    this._init();
  }

  _init() {

    const header = document.querySelector('header');

    if (!header) return;
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        header?.classList.add('scrolled');
      } else {
        header?.classList.remove('scrolled');
      }
    });
    const burger = document.querySelector('.header__burger');
    const menu = document.querySelector('.header__menu');
    burger?.addEventListener('click', function () {
      if (burger.classList.contains('active')) {
        burger.classList.remove('active');
        menu?.classList.remove('active');
        header?.classList.remove('active');
      } else {
        burger.classList.add('active');
        menu?.classList.add('active');
        header?.classList.add('active');
      }
    });
  }

}

export const header = new Header();
